// Utils
import { updateElement } from '../actions/elementActions';

// Constants
import { ELEMENT_UPDATE_TYPE } from '../../../common/elements/elementConstants';

export const setTaskCompletion =
    ({ id, isComplete, transactionId }) =>
    (dispatch) => {
        return dispatch(
            updateElement({
                id,
                updateType: ELEMENT_UPDATE_TYPE.TOGGLE_COMPLETION,
                changes: { isComplete },
                transactionId,
            }),
        );
    };
